import React from 'react';
import {
  Box,
  Button,
  Grid,
  Modal,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';

import IMG_HELP_01 from "../../assets/img/help-01.png";


export default function AccountExpiredModal({
  visible,
  onClose,
}) {
  const theme = useTheme();

  return (
    <Modal
      open={visible}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minWidth: '350px',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 5.5,
          maxHeight: '95%',
          overflowY: 'auto',
          '::-webkit-scrollbar': {
            width: '12px',
          },
          '::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
          },
          '::-webkit-scrollbar-thumb': {
            borderRadius: '6px',
            border: '3px solid transparent',
            backgroundClip: 'content-box',
            backgroundColor: '#c1c1c1',
          }
        }}
      >
      <Grid sx={{ width: '100%', margin: 'auto' }} className="text-center">
        <Box component="img" src={IMG_HELP_01} style={{ width: '300px' }} />
        <Typography id="modal-modal-title" sx={{ fontSize: '1.8rem', fontWeight: 700, lineHeight: '1.2', mt: 2, textAlign: 'center' }}>
          Your account has expired
        </Typography>
        <Typography id="modal-modal-description" sx={{ fontSize: '0.85rem', fontWeight: 400, mt: 1.5, textAlign: 'center', color: theme.palette.mode === 'light' ? '#3f4254' : '#e0e0e0' }}>
          Please send an email to our support team
        </Typography>
        <Grid item container direction='row' justifyContent='center' alignItems='center' display="flex" sx={{ mt: 3 }}>
          <Button
            color="success"
            variant="contained"
            sx={{ fontSize: '0.9rem', fontWeight: 500, padding: '10px 30px', textTransform: 'none', color: '#fff' }}
            onClick={onClose}
          >
            Submit Ticket
          </Button>
        </Grid>
      </Grid>
      </Box>
    </Modal>
  );
}

AccountExpiredModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};
